import React, {useState} from "react";
import Button from "reactstrap/lib/Button";
import Form from "reactstrap/lib/Form";
import Modal from "reactstrap/lib/Modal";
import ModalBody from "reactstrap/lib/ModalBody";
import ModalHeader from "reactstrap/lib/ModalHeader";
import {t} from "react-switch-lang";
import './Modals.css';

import {DeleteAllNotificationApi} from "../../services/notifications/NotificationsApi";
import Exclusion from "./img/Exclusion 2.svg";

export function DeleteAllNotification(props) {
    const [modal, setModal] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const userModal = () => setModal(!modal);

    const handleSubmitUnread = event => {
        event.preventDefault();
        DeleteAllNotificationApi("delivered").then((res) => {
            props.setRowChanged();
            setModal(!modal);
            setIsButtonDisabled(false);
        })
    };

    const handleSubmitRead = event => {
        event.preventDefault();
        DeleteAllNotificationApi("read").then((res) => {
            props.setRowChanged();
            setModal(!modal);
            setIsButtonDisabled(false);
        })
    };

    return (
        <>
            <button className="editNotification" onClick={userModal}
                    style={{color: "#f5501f"}}>
                {`${t('buttons.deleteAllBtn')}`}
            </button>
            <Modal isOpen={modal} toggle={userModal}
                   className="modal-md modalDelete" backdrop="static">
                <ModalHeader toggle={userModal}>
                    {props.type === "delivered"
                        ?
                        <div>{t('buttons.deleteBtn')} {t('question.deleteAllUnread').toLowerCase()} </div>
                        :
                        <div>{t('buttons.deleteBtn')} {t('question.deleteAllRead').toLowerCase()} </div>
                    }
                    <img src={Exclusion} alt="Exclusion" onClick={userModal}
                         style={{cursor: "pointer"}}/>
                </ModalHeader>
                <ModalBody className="d-flex flex-row">
                    <div>
                        <div className="row">
                            <div className="py-2 my-2">
                                {props.type === "delivered"
                                    ?
                                    <h3> {`${t('question.delete2')} ${t('question.deleteAllUnread')} ?`}</h3>
                                    :
                                    <h3> {`${t('question.delete2')} ${t('question.deleteAllRead')} ?`}</h3>
                                }
                            </div>
                            <div
                                className="container-fluid decorationLine"></div>
                            <div className="text-righ offset-5">
                                <Button onClick={userModal}
                                        className="danger cancelButton">
                                    {t('buttons.cancelBtn')}
                                </Button>
                            </div>
                            <div className="text-right">
                                {props.type === "delivered"
                                    ? <Form
                                        onSubmit={(e) => handleSubmitUnread(e)}
                                        noValidate
                                        className="d-flex justify-content-between">
                                        <Button className="primary deleteButton"
                                                disabled={isButtonDisabled}>
                                            {t("buttons.deleteBtn")}{" "}
                                        </Button>
                                    </Form>
                                    :
                                    <Form onSubmit={(e) => handleSubmitRead(e)}
                                          noValidate
                                          className="d-flex justify-content-between">
                                        <Button className="primary deleteButton"
                                                disabled={isButtonDisabled}>
                                            {t("buttons.deleteBtn")}{" "}
                                        </Button>
                                    </Form>
                                }
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </>
    );
}
